// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-document-card-menu{background:var(--color-silver);display:flex;justify-content:space-between;position:relative}.contact-document-card-menu__title{font-size:12px;height:50px;margin:0;overflow:hidden;padding:10px 0 0 20px;width:70%}.contact-document-card-menu__items{display:flex;align-items:center}.contact-document-card-menu__link{font-family:var(--font-regular);font-size:16px;font-weight:400}", ""]);
// Exports
module.exports = exports;
